// src/hooks/usePaymentMethods.js
import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchData } from "../api/client";

export const usePaymentMethods = (page = 1, limit = 10, search = "", extra = {}) => {
  const queryClient = useQueryClient();
  const idsProjetos = extra.ids_projetos != null && extra.ids_projetos !== "" ? String(extra.ids_projetos) : "";

  const query = useQuery(
    ["paymentMethods", page, limit, search, idsProjetos],
    () => {
      const qs = new URLSearchParams({
        page: String(page),
        limit: String(limit),
        search: search || "",
      });
      if (idsProjetos) qs.set("ids_projetos", idsProjetos);
      return fetchData(`/payment-methods?${qs.toString()}`);
    },
    {
      staleTime: 5000,
      refetchOnWindowFocus: false,
      select: (response) => {
        // ✅ Extrai array e paginação, independente do shape
        const payload = response ?? {};
        const inner = payload.data ?? {};

        const arr =
          Array.isArray(inner.data) ? inner.data :
          Array.isArray(payload.data) ? payload.data :
          Array.isArray(payload) ? payload :
          [];

        const pagination =
          inner.pagination ??
          payload.pagination ??
          { total: arr.length, page, limit };

        return { paymentMethods: arr, pagination };
      },
    }
  );

  const updateMutation = useMutation(
    (method) => {
      const endpoint = method.id ? `/payment-methods/${method.id}` : `/payment-methods`;
      const methodType = method.id ? "PUT" : "POST";
      return fetchData(endpoint, methodType, method);
    },
    { onSuccess: () => queryClient.invalidateQueries("paymentMethods") }
  );

  const updateStatusMutation = useMutation(
    ({ id, status }) => fetchData(`/payment-methods/${id}`, "PUT", { status }),
    { onSuccess: () => queryClient.invalidateQueries("paymentMethods") }
  );

  const deleteMutation = useMutation(
    (id) => fetchData(`/payment-methods/${id}`, "DELETE"),
    { onSuccess: () => queryClient.invalidateQueries("paymentMethods") }
  );

  return { ...query, updateMutation, updateStatusMutation, deleteMutation };
};
